import { Slider } from '@mui/material';
import React from 'react';

interface ThicknessSliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

export const ThicknessSlider: React.FC<ThicknessSliderProps> = ({
  value,
  onChange,
  min = 1,
  max = 10,
  step = 1,
}) => {
  return (
    <Slider
      value={value}
      onChange={(e, value) => onChange(value as number)}
      min={min}
      max={max}
      step={step}
      size="small"
      sx={{ width: '100%' }}
    />
  );
};
